<template>
    <div><div style="display: none !important;"><svg><symbols><symbol id="sprite-triangle-left"><path data-name="Polygone 2 copie 4 copy 2 copie" d="M0 5l6-5v10z" fill-rule="evenodd"/></symbol><symbol id="sprite-triangle-right"><path data-name="Polygone 2 copie 4 copy 2 copie" d="M6 5l-6 5V0z" fill-rule="evenodd"/></symbol></symbols></svg></div>
        <div v-if="lastItem >= 10 && count > 10" class="pagination flex-container align-center align-middle cell">
            <button type="button" class="btn" :disabled="!previous" @click="switchPage(-1)">
                <svg inline="" width="10" height="15" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 10"><use xlink:href="#sprite-triangle-left"></use></svg>
            </button>
            <span v-translate="{firstPage: current, lastPage: totalPages}">Page %{ firstPage } of %{ lastPage }</span>
            <button type="button" class="btn" :disabled="!next" @click="switchPage(1)">
                <svg inline="" width="10" height="15" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 10"><use xlink:href="#sprite-triangle-right"></use></svg>
            </button>
        </div>
    </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
    props: ['next', 'previous', 'count', 'current', 'pageSize'],
    computed: {
        firstItem () {
            return (this.current - 1) * this.pageSize + 1;
        },
        lastItem () {
            return  this.current * this.pageSize > this.count ? this.count: this.current * this.pageSize;
        },
        totalPages () {
            return parseInt(this.count / this.pageSize) + 1;
        }
    },
    methods: {
        switchPage (direction) {
            this.$emit('onSwitchPage', direction);
            this.scrollTop();
        },
        scrollTop () {
            VueScrollTo.scrollTo('.container', 250, { easing: 'ease-in', offset: 0, cancelable: true, y: true });
        },
    }
};
</script>

<style lang="scss" scoped>
.btn {
    color: $c-atelier;
    padding: 10px 16px;
    &:disabled {
        color: $c-button-disabled;
    }
}
.btn-label {
    display: none;
    @include breakpoint(375px) {
        display: inline;
    }
}
svg {
    fill: currentColor;
    vertical-align: middle;
    margin: 0 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/utils/BmrPagination.vue